module.exports = "<symbol id=\"tt-icon-flag-on\" viewBox=\"0 0 24 24\"><path d=\"M16.52 2.64l5.75.36v13.83h-8.44l-2.75-2.72h-6.7v9.66H1.73V.23h12.1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/Rdhcya1h7lLN3rcsite/assets/svg/pdp-page/flag-on.svg
// module id = 257
// module chunks = 10